import "./Comcafundi.scss";
import { useEffect, useRef, useState } from "react";
import CarCardComponent from "../../components/carCard/CarCardComponent";
import CarEntity from "../../../../domain/entities/CarEntity";

import Button from "../../components/Button";
import Carousel from "react-multi-carousel";
import CardCarouselcomfacundi from "./components/CardCarouselComcafundi";
import { FaFacebookF, FaInstagram, FaYoutube, FaLinkedinIn } from "react-icons/fa";
import { Link } from "react-router-dom";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import CarImplDto from "../../../../data/dto/impl/CarImplDto";
import ModalBanner from "../../components/ModalBanner/ModalBanner";
import { Helmet } from "react-helmet-async";
import { API_URL, GOOGLE_MAPS_API_KEY } from "../../../../config/env";

const Landingcomfacundi = () => {
    const [showBanner, setShowBanner] = useState(true);
    const dataCarousel = [
        {
            title: "Financiación a tu medida",
            img: "/assets/comcafundi/financiacion-image-comcafundi.svg",
            description:
                "Si quieres cambiar de nave, accede a planes flexibles con tasas preferenciales por ser afiliado comcafundi",
        },

        {
            title: "Garantía de 6 meses y Garantía de Felicidad",
            img: "/assets/comcafundi/garantia-de-6-meses-comcafundi.svg",
            description:
                "El 90% de nuestros vehículos incluyen garantía mecánica y una Garantía de Felicidad: si no te enamoras de tu compra, te ayudamos a cambiarla.",
        },
        {
            title: "Peritaje certificado en todos los vehículos",
            img: "/assets/comcafundi/peritaje-certificados-en-todos-los-vehiculos.svg",
            description:
                "Cada carro y moto pasa por un peritaje técnico completo, garantizando transparencia y confianza en cada negocio.",
        },
        {
            title: "Pago rápido y sin enredos",
            img: "/assets/comcafundi/pago-sin-enredado.svg",
            description: "Vende tu carro o moto y recibe el dinero en tiempo récord. Sin vueltas, sin cuentos.",
        },
    ];

    const location1 = {
        lat: 4.691959880308249,
        lng: -74.07611493603319,
    };
    const location2 = {
        lat: 4.902005263873653,
        lng: -74.03039745767153,
    };
    const location3 = {
        lat: 4.691388319180716,
        lng: -74.07598815868705,
    };
    const location4 = {
        lat: 4.691667638838912,
        lng: -74.07556760447528,
    };
    const center = {
        lat: (location1.lat + location2.lat) / 2,
        lng: (location1.lng + location2.lng) / 2,
    };

    const mapContainerStyle = {
        width: "98%",
        height: "180px",
    };

    const [cars, setCars] = useState<CarEntity[] | undefined>([]);
    const ids = [2067, 1969, 2054, 2103, 1968, 2013];

    const fetchAllCars = async () => {
        try {
            const carPromises = ids.map((id) =>
                fetch(`${API_URL}/cars/${id}`).then((response) => {
                    if (!response.ok) {
                        throw new Error(`Error en la petición para el ID ${id}: ${response.statusText}`);
                    }
                    return response.json();
                }),
            );

            const allCars = await Promise.all(carPromises);
            setCars(allCars.map((car: any) => CarImplDto.fromJson(car)).filter((car: CarEntity) => car.id != "19"));
        } catch (err) {
            // setError(err.message);
        } finally {
            // setLoading(false);
        }
    };

    useEffect(() => {
        fetchAllCars();
    }, []);

    const responsive = {
        desktop: {
            breakpoint: { max: 4000, min: 1300 },
            items: 4,
        },
        tablet: {
            breakpoint: { max: 1300, min: 767 },
            items: 1,
        },
        mobile: {
            breakpoint: { max: 767, min: 0 },
            items: 1,
        },
    };

    useEffect(() => {
        const scriptContent = `
!function(a,m,o,c,r,m){a[o+c]=a[o+c]||{setMeta:function(p){this.params=(this.params||[]).concat([p])}},a[o+r]=a[o+r]||function(f){a[o+r].f=(a[o+r].f||[]).concat([f])},a[o+r]({id:"1565724",hash:"44fd76a2d3a3af4c8f7d625d6ca209df",locale:"es"}),a[o+m]=a[o+m]||function(f,k){a[o+m].f=(a[o+m].f||[]).concat([[f,k]])}}(window,0,"amo_forms_","params","load","loaded");`;
        const script = document.createElement("script");
        script.async = true;
        script.innerHTML = scriptContent;
        document.body.appendChild(script);

        const kommoScript = document.createElement("script");
        kommoScript.id = "amoforms_script_1565724";
        kommoScript.async = true;
        kommoScript.src = "https://forms.kommo.com/forms/assets/js/amoforms.js?1761926862";

        setTimeout(() => {
            document.getElementById("form-nuevo")?.appendChild(kommoScript);
            document.getElementById("form-nuevo-2")?.appendChild(kommoScript);
        }, 1000); // Espera 1 segundo para asegurarse de que todo el DOM esté cargado

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    return (
        <div className="container-linktree text-center comfacundi_page">
            <Helmet>
                <title>Comfacundi - wcar</title>
            </Helmet>
            <section className="section_1-comfacundi position-relative">
                <div className="content position-md-absolute mt-4 mt-md-0 ">
                    <div className="">
                        <div className="col-md-7 div-header">
                            <img
                                src="/assets/services/logos-wcar-comcafundi.svg"
                                width={"100%"}
                                alt=""
                                style={{ marginTop: -80, margin: "auto", marginRight: 0 }}
                                className="image-logo-comfacundi"
                            />
                            <div className="d-none d-md-block pt-6 mb-3 " style={{ paddingBottom: 50 }} />
                            <h2 className="text-white text_bold text-center text-md-start text-header-comfacundi ">
                                <i style={{ fontWeight: 700, fontSize: 50 }}>
                                    ENCUENTRA TU CARRO O MOTO SOÑADA <br />
                                </i>
                                <i className="text_italice " style={{ fontWeight: 600 }}>
                                    CON LOS MEJORES BENEFICIOS
                                </i>
                            </h2>
                        </div>

                        <br />
                        <div className="d-flex justify-content-center d-md-block div-header">
                            <Button label="RESERVAR VEHÍCULO AHORA" onClick={() => {}} />
                        </div>
                    </div>
                </div>
            </section>
            <section className="" style={{ display: "flex", justifyContent: "center" }}>
                <div className={"container-form"}>
                    <div className={"form"}>
                        <div id="form-nuevo-2"></div>
                    </div>
                </div>
            </section>

            <section className={"section-carousel"}>
                <h3 className="text-title">
                    Así aseguramos que cada negocio <br /> sea <i className={"text_orange"}>un buen negocio</i>
                </h3>
                <p className={"paragraph-title"}>
                    En WCAR cuidamos cada detalle para que vender o comprar tu carro o <br /> moto sea una experiencia
                    segura, memorable y sin enredos.
                </p>
            </section>
            <div className="d-flex container-box-carousel">
                <div className={" mt-5 container-carousel"}>
                    {[...dataCarousel].splice(0, 2)?.map((item: any, i: number) => {
                        return <CardCarouselcomfacundi item={item} />;
                    })}
                </div>
                <div className={" mt-5 container-carousel"}>
                    {dataCarousel.splice(2, 2)?.map((item: any, i: number) => {
                        return <CardCarouselcomfacundi item={item} />;
                    })}
                </div>
            </div>

            <div
                className=" mt-5 "
                style={{
                    backgroundColor: "#F6F7F9",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    position: "relative",
                }}
            >
                <h4 className={"sub_title_2 mt-4 mb-5"}>
                    Compra el vehículo que <i className="text-orange">mas se ajuste a ti</i>
                </h4>
                <div
                    className="container row mt-3"
                    style={{
                        position: "relative",
                    }}
                >
                    <img
                        src="/assets/pages/error404/wcar.svg"
                        alt="wcar"
                        title="wcar"
                        className="src_1"
                        style={{ position: "absolute", marginTop: -30 }}
                    />

                    {cars.map((car, index) => (
                        <div className={`mb-3 ${"col-md-12 col-lg-6 col-xl-4"}`} key={car.id}>
                            <CarCardComponent car={car} />
                        </div>
                    ))}
                </div>
            </div>
            <footer className={""}>
                <div
                    style={{
                        minHeight: 311,
                        backgroundColor: "white",
                        justifyContent: "space-evenly",
                        alignItems: "center",
                    }}
                    className="container-footer"
                >
                    <div className="d-flex container-navigation">
                        <div className={"container-navigation-item"}>
                            <p className=" title">Navegación</p>

                            <div>
                                <p>Inicio</p>
                                <p>Servicios</p>
                                <p>Motos</p>
                            </div>
                        </div>
                        <div className={"container-navigation-item "} style={{ marginBottom: 32 }}>
                            <p className=" title">Legal</p>

                            <div>
                                <p>Términos y condiciones usuarios</p>
                                <p>Políticas y tratamiento de datos</p>
                            </div>
                        </div>
                    </div>
                    <div className="social-media">
                        <p>Siguenos</p>
                        <div className="sm-enlaces">
                            <Link to="https://www.facebook.com/wcarcolombia?mibextid=ZbWKwL" target="_blank">
                                <div className="sm-item">
                                    <FaFacebookF size={16} />
                                </div>
                            </Link>
                            <Link
                                to="https://www.instagram.com/wcar.oficial?igshid=NGVhN2U2NjQ0Yg%3D%3D"
                                target="_blank"
                            >
                                <div className="sm-item">
                                    <FaInstagram size={18} />
                                </div>
                            </Link>
                            <Link to="https://www.youtube.com/@wcarcolombia?si=SAfvApSkimvFnxHK" target="_blank">
                                <div className="sm-item">
                                    <FaYoutube size={19} />
                                </div>
                            </Link>
                            <Link to="https://www.linkedin.com/company/wcarcol/" target="_blank">
                                <div className="sm-item">
                                    <FaLinkedinIn size={16} />
                                </div>
                            </Link>
                        </div>
                    </div>
                    <div className={"container-map-comfacundi"}>
                        <LoadScript googleMapsApiKey={GOOGLE_MAPS_API_KEY}>
                            <GoogleMap mapContainerStyle={mapContainerStyle} center={center} zoom={9}>
                                <Marker position={location1} />
                                <Marker position={location4} />
                                <Marker position={location2} />
                                <Marker position={location3} />
                            </GoogleMap>
                        </LoadScript>
                    </div>
                </div>
                <div
                    style={{
                        minHeight: 211,
                        backgroundColor: "#F6F7F9",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                    }}
                    className="container container-bottom-footer"
                >
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <img src="/assets/logos/horizontal.svg" alt="" width={176} height={70} />
                        <div style={{ height: 50, width: 2, background: "#90A3BF", marginRight: 10 }}></div>
                        <img src="/assets/logos/comcafundi.svg" alt="" />
                    </div>
                    <img src="/assets/logos/supersubsidio.svg" alt="" />
                </div>
                <div className="divider divider-last-desk">
                    <div className="box-industria-comercio">
                        <div className="text-center text-md-start">
                            <p className="text-rights">
                                Wcar y comfacundi - Todos los derechos reservados © {new Date().getFullYear() || 2026}
                            </p>
                        </div>
                        <div className="bg-white" />
                    </div>
                </div>
            </footer>
            {showBanner && (
                <ModalBanner
                    imageMobile="/assets/pop-up-comfacundi.webp"
                    imageDesktop="/assets/pop-up-comfacundi.webp"
                    setIsOpen={setShowBanner}
                />
            )}
        </div>
    );
};

export default Landingcomfacundi;
